import { render, staticRenderFns } from "./NavbarMapping.vue?vue&type=template&id=022109b7"
import script from "./NavbarMapping.vue?vue&type=script&lang=js"
export * from "./NavbarMapping.vue?vue&type=script&lang=js"
import style0 from "./NavbarMapping.vue?vue&type=style&index=0&id=022109b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports